// Name is links.json in i18n folder
const Home = {
  type: 'home',
  url: '',
  img: [],
};
const Services = {
  type: 'services',
  url: 'chauffeur-prive',
  img: [],
};
const Contact = {
  type: 'contact',
  url: 'contact',
  img: [],
};
const Cars = {
  type: 'cars',
  url: 'cars',
  img: [],
};
const Links = [
  Home,
  Services,
  Cars,
  Contact,
];

export default Links;
